'use client'
import {useEffect} from "react";
import * as amplitude from "@amplitude/analytics-browser";
import ReactGA from "react-ga4";
import {AMPLITUDE_API_KEY, GOOGLE_ID, LOG_EVENTS} from "./config";
import {useAuth} from "./hooks/useAuth";
import {logEvent, paramsGet, paramsRemove, useUser} from "./utils";
import {mapAnonUser, utmRequest} from "./requests";
import {rootStore, useStores} from "./stores/root";
import {observer} from "mobx-react-lite";


export const InitAppComponent = observer(({children}) => {
    const {authenticated, login, ready} = useAuth()
    const {user: userStore, input} = useStores()
    const user = useUser()
    const username = user?.username

    // SAVE UTM
    useEffect(() => {
        console.log("Utm effect")
        const params = new URLSearchParams(window.location.search);
        if (params.has("utm_source")) {
            console.log("Save utm")
            const utm = {
                "utm_source": params.get("utm_source"),
                "utm_medium": params.get("utm_medium"),
                "utm_campaign": params.get("utm_campaign"),
                "utm_term": params.get("utm_term"),
                "utm_content": params.get("utm_content"),
            }
            localStorage.setItem("utm", JSON.stringify(utm))
            utmRequest(utm)
        }
    }, []);


    // INIT AMPLITUDE
    useEffect(() => {
        console.log("Init amplitude effect")
        const url = new URL(window.location.href)
        const utm_source = url.searchParams.get("utm_source");
        if (!!AMPLITUDE_API_KEY) {
            amplitude.init(AMPLITUDE_API_KEY, {
                serverZone: "EU",
                autocapture: true,
                optOut: (utm_source === 'health-checker') || !LOG_EVENTS
            })
            console.log("Init amplitude", "LOG_EVENTS=", LOG_EVENTS)
        } else {
            console.log("No amplitude")
        }
    }, [])

    // SEND CONSENT
    useEffect(() => {
        // TODO make like in landing
        // https://medium.com/@sdanvudi/configuring-google-cookies-consent-with-next-js-15-ca159a2bea13
        console.log("Init consent effect")
        const setConsent = () => {
            const consentMode = {
                'functionality_storage': 'granted',
                'security_storage': 'granted',
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'personalization_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
            };
            ReactGA.gtag('consent', 'update', consentMode);
            localStorage.setItem("consent", "true");
            logEvent("consent__update")
        }

        const consent = localStorage.getItem("consent");
        if (consent) return;
        setTimeout(setConsent, 2000)
    }, []);

    // SET USER LOGGED
    useEffect(() => {
        if (!username) return;
        console.log("Set amplitude and ga4 user_id effect")
        amplitude.setUserId(username)
        // https://developers.google.com/analytics/devguides/collection/ga4/user-id?client_type=gtag
        ReactGA.gtag("config", GOOGLE_ID, {user_id: username});
        console.log("Set amplitude and ga4 user_id", username)

    }, [username])


    // WHEN NOT AUTHENTICATED
    useEffect(() => {
        if (authenticated) return;
        if (!ready) return;
        console.log("Not authenticated effect")

        const from = paramsGet("from")
        if (from) {
            localStorage.setItem("uuid", from)
            paramsRemove("from")
        }

        const token = paramsGet("token")
        if (token) {
            userStore.auth(token)
            paramsRemove("token")
        } else if (localStorage.getItem("token")) {
            userStore.auth(localStorage.getItem("token"))
        } else {
            login()
        }
    }, [authenticated, ready]);

    useEffect(() => {
        (async () => {
            if (localStorage.getItem('token')) {
                await userStore.refresh();
            }
            userStore.setIsLoading(false);
        })();

    }, []);

    // WHEN AUTHENTICATED
    useEffect(() => {
        if (!authenticated) return;
        rootStore.refresh()
        console.log("Authenticated effect")
        if (paramsGet("token")) paramsRemove("token");
        const uuid = paramsGet("from")
        if (uuid) {
            localStorage.setItem("uuid", uuid)
            mapAnonUser(uuid)
            paramsRemove("from")
        }
        const text = paramsGet("text")
        if (text) {
            paramsRemove("text")
            input.setText(text)
        }
    }, [authenticated])

    return <>
        {children}
    </>
})